import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { Endpoint } from '../../../constants/endpoints';

export interface SearchAllMedicationsProps {
  currentBarcode?: string;
  prescriptionNumber: number;
  prescriptionType?: string;
  scheduleDate: string;
  scheduleSequenceNumber: number;
}

export interface ReadOneMedicationCardProps {
  barcode: string;
  doseQuantity?: number;
  prescriptionNumber: number;
  prescriptionType?: string;
  scheduleDate: string;
  scheduleSequence: number;
}

export default class AdminMedicationScheduleReadingCard {

  public static searchAllMedicationsPendding(data: SearchAllMedicationsProps): Promise<Record<string, Value>[]> {
    const { prescriptionNumber, scheduleDate, scheduleSequenceNumber, prescriptionType } = data;

    const endpoint = prescriptionType ? Endpoint.EMAR_GET_MEDICATIONS_PENDING_PRESCRIPTION_TYPE : Endpoint.EMAR_GET_MEDICATIONS_PENDING;

    return HttpService.get(endpoint, {
      prescriptionNumber,
      prescriptionType,
      scheduleDate,
      scheduleSequence: scheduleSequenceNumber,
    }).then(response => {
      return response.body as Record<string, Value>[];
    });
  }

  public static readOneMedicationCard(data: ReadOneMedicationCardProps): Promise<void | Record<string, Value>> {
    const body = Object.assign({}, data) as unknown as Record<string, Value>;

    return HttpService.post(Endpoint.EMAR_READ_ONE_MEDICATIONS_CARD, {},
      { body }
    ).then((res) => {
      return res.body as Record<string, Value>;
    });
  }
}
